import { io } from "socket.io-client";

let socket;

if (!socket) {
  socket = io(window.location.origin, {
    path: "/socket.io",
    transports: ["websocket"],
  });

  socket.on("connect", () => {
    console.log("SOCKET CONNECTED:", socket.id);
  });

  socket.on("connect_error", (error) => {
    console.log("SOCKET CONNECT ERROR:", error.message);
  });

  socket.on("disconnect", () => {
    console.log("SOCKET DISCONNECTED");
  });
}

export { socket };
